import React from 'react';
import './FamilyHubSection.css';

/**
 * Placeholder shell for family hub areas (Forum, Contacts, Calendar) until dedicated features ship.
 */
export default function FamilyHubSection({ title, description, icon, onBack }) {
  return (
    <div className="family-hub-page">
      <header className="family-hub-toolbar">
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          ← Home
        </button>
      </header>
      <div className="family-hub-body">
        {icon ? (
          <span className="family-hub-icon" aria-hidden>
            {icon}
          </span>
        ) : null}
        <h1 className="family-hub-title">{title}</h1>
        <p className="family-hub-desc">{description}</p>
      </div>
    </div>
  );
}
